<template>
  <router-link
    to="/alerts"
    style="position: relative; text-decoration: none;"
    aria-label="Alerts"
    class="btn-tertiary"
  >
    <span
      class="material-symbols-rounded"
      style="font-size: 1.25rem; color: var(--color-on-surface);"
    >
      notifications
    </span>
    <span
      v-if="badgeCount > 0"
      class="alerts-bell-badge"
    >
      {{ badgeCount > 9 ? "9+" : badgeCount }}
    </span>
  </router-link>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue"
import { useAlertsStore } from "@/stores/alerts"

const store = useAlertsStore()
const badgeCount = computed(() => store.activeCount)

onMounted(() => {
  if (store.items.length === 0) store.fetch()
})
</script>

<style scoped>
.alerts-bell-badge {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 1.125rem;
  height: 1.125rem;
  padding: 0 0.3rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--color-error);
  color: var(--color-on-error);
  border-radius: 9999px;
  font-family: 'Manrope', sans-serif;
  font-size: 0.625rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  line-height: 1;
}
</style>
